(() => {
  if (window.dwproVendorTables) return;
  window.dwproVendorTables = true;

  const text = (cell) => (cell?.textContent || '').replace(/\s+/g, ' ').trim();
  const cellSpans = (cell) => cell.colSpan > 1 || cell.rowSpan !== 1;

  function gridFor(table) {
    const rows = Array.from(table.rows).filter((row) => row.closest('table') === table);
    const grid = [];
    rows.forEach((row, y) => {
      grid[y] ||= [];
      let x = 0;
      Array.from(row.cells).forEach((cell) => {
        while (grid[y][x]) x++;
        const across = cell.colSpan || 1;
        const down = cell.rowSpan === 0 ? rows.length - y : cell.rowSpan || 1;
        for (let yy = y; yy < Math.min(rows.length, y + down); yy++) {
          grid[yy] ||= [];
          for (let xx = x; xx < x + across; xx++) grid[yy][xx] = cell;
        }
        x += across;
      });
    });
    return { rows, grid, width: Math.max(0, ...grid.map((row) => row.length)) };
  }

  function addFact(list, label, value) {
    const pair = document.createElement('div');
    pair.className = 'dwpro-spec-fact';
    const term = document.createElement('dt');
    term.textContent = label;
    const detail = document.createElement('dd');
    detail.textContent = value;
    pair.append(term, detail);
    list.append(pair);
  }

  function card(view, title, facts) {
    const item = document.createElement('section');
    item.className = 'dwpro-spec-card';
    if (title) {
      const heading = document.createElement('h3');
      heading.className = 'dwpro-spec-card__title';
      heading.textContent = title;
      item.append(heading);
    }
    const list = document.createElement('dl');
    list.className = 'dwpro-spec-card__facts';
    facts.forEach(([label, value]) => addFact(list, label, value));
    item.append(list);
    view.append(item);
  }

  function mobileView(table, vendor, data) {
    const { rows, grid, width } = data;
    if (rows.length < 2 || table.querySelector('img, video, iframe, input, button, a, table')) return null;
    const view = document.createElement('div');
    view.className = 'dwpro-specs-mobile';
    const headers = grid[0].map(text);
    const notes = [];

    if (width === 2 && rows.every((row) => row.cells.length === 2 && Array.from(row.cells).every((cell) => !cellSpans(cell)))) {
      if (grid.some((row) => !text(row[0]))) return null;
      card(view, '', grid.map((row) => [text(row[0]), text(row[1])]));
      return view;
    }

    if (width < 3 || rows[0].cells.length !== width || Array.from(rows[0].cells).some(cellSpans)) return null;

    const byColumn = vendor === 'HA' && (!headers[0] || /^(model|product|item|specification|parameter)\b/i.test(headers[0]));
    if (byColumn) {
      if (headers.slice(1).some((label) => !label) || rows.slice(1).some((row) => row.cells.length !== width || Array.from(row.cells).some(cellSpans))) return null;
      if (grid.slice(1).some((row) => !text(row[0]))) return null;
      for (let column = 1; column < width; column++) {
        card(view, headers[column], grid.slice(1).map((row) => [text(row[0]), text(row[column])]));
      }
      return view;
    }

    if (headers.some((label) => !label)) return null;
    const body = [];
    for (let index = 1; index < rows.length; index++) {
      const row = rows[index];
      const cells = Array.from(row.cells);
      const values = cells.map(text).filter(Boolean);
      if (!values.length) continue;
      if (cells.some((cell) => cell.colSpan > 1) && values.length === 1 && grid[index].length === width) {
        notes.push(values[0]);
        continue;
      }
      if (cells.some((cell) => cell.colSpan > 1) || grid[index].length !== width || grid[index].some((cell) => !cell)) return null;
      body.push(grid[index].map(text));
    }
    if (!body.length) return null;
    const modelIndex = headers.findIndex((label) => /model|sku|item no|code/i.test(label));
    body.forEach((values) => {
      const title = modelIndex >= 0 ? values[modelIndex] : headers[0] + ': ' + values[0];
      card(view, title, headers.map((label, index) => [label, values[index]]));
    });
    notes.forEach((value) => {
      const note = document.createElement('p');
      note.className = 'dwpro-spec-note';
      note.textContent = value;
      view.append(note);
    });
    return view;
  }

  function enhance() {
    document.querySelectorAll('product-info[data-product-vendor]').forEach((root) => {
      const vendor = root.dataset.productVendor.trim().toUpperCase();
      if (!['EB', 'HA'].includes(vendor)) return;
      root.querySelectorAll('.product__description table').forEach((table) => {
        if (table.dataset.dwproResponsive) return;
        table.dataset.dwproResponsive = 'true';
        const data = gridFor(table);
        if (!data.width) return;
        const view = mobileView(table, vendor, data);
        const frame = document.createElement('div');
        frame.className = 'dwpro-specs-table-frame';
        table.before(frame);
        frame.append(table);
        if (view) {
          frame.classList.add('dwpro-specs-table-frame--cards');
          frame.after(view);
          table.dataset.dwproLayout = vendor === 'HA' && !text(data.grid[0][0]) ? 'column-cards' : 'row-cards';
        } else {
          frame.classList.add('dwpro-specs-scroll');
          frame.style.setProperty('--dwpro-table-min-width', Math.max(480, data.width * 125) + 'px');
          frame.tabIndex = 0;
          frame.setAttribute('role', 'region');
          frame.setAttribute('aria-label', root.dataset.dwproTableScrollLabel);
          const hint = document.createElement('p');
          hint.className = 'dwpro-specs-scroll-hint';
          hint.textContent = root.dataset.dwproTableScrollHint;
          frame.before(hint);
          table.dataset.dwproLayout = 'scroll';
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
  new MutationObserver((records) => {
    const relevant = records.some((record) => Array.from(record.addedNodes).some((node) => {
      return node.nodeType === 1 && (node.matches('product-info, .product__description') || node.querySelector('product-info, .product__description'));
    }));
    if (relevant) enhance();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();